module.exports = __webpack_public_path__ + "img/ES0038.8129b4ab.png";